var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlaceholder = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 220"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Misc"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    fill: "transparent",
    width: 140,
    height: 220
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#BFDBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 70,
    cy: 125,
    rx: 31.5,
    ry: 31.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#BFDBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 70,
    cy: 125,
    rx: 22.1,
    ry: 22.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#BFDBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M137,85.4h-33V73.9 c0-1.7-1.3-3-3-3H39.1c-1.7,0-3,1.3-3,3v11.6H3c-1.7,0-3,1.3-3,3v73.1c0,1.7,1.3,3,3,3h134c1.7,0,3-1.3,3-3V88.4 C140,86.8,138.7,85.4,137,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#BFDBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M28,99.2H12.5 c-1.7,0-3-1.3-3-3v-0.6c0-1.7,1.3-3,3-3H28c1.7,0,3,1.3,3,3v0.6C31,97.8,29.7,99.2,28,99.2z"
  })))));
};

export default SvgPlaceholder;